export default function Row({ style, data }) {
  const {
    source,
    path,
    isComparing,
    memoizedGaMetricsForPath,
    gaMetricsForPages,
    gaMetricsForPagesTwo,
    calculatePercentageDifference,
    calculatePercetageOfSecondValue,
  } = data;

  const count = gaMetricsForPages ? memoizedGaMetricsForPath(gaMetricsForPages, path, source.source, source.medium) : '-';
  const countTwo = gaMetricsForPagesTwo ? memoizedGaMetricsForPath(gaMetricsForPagesTwo, path, source.source, source.medium) : '-';

  return (
    <div style={style}>
      <div className="d-flex" style={{ height: '100%', borderBottom: '1px solid #312852' }}>
        <div style={{ width: '25%', padding: '0.5rem', textWrap: 'wrap' }}>
          {source.source === '(direct)' ? <i>Direct</i> : `${source.source} / ${source.medium}`}
        </div>
        <div style={{ width: '25%', padding: '0.5rem' }}>
          <div className="d-flex gap-2">
            <span className="fs-4">{source.count} </span>
            {isComparing && (
              <span className="text-muted">
                | {`${source.countTwo ?? '-'} ${source.count && source.countTwo ? `(${calculatePercentageDifference(source.count, source.countTwo)})` : ''}`}
              </span>
            )}
          </div>
        </div>
        <div style={{ width: '25%', padding: '0.5rem' }}>
          <span className={count >= 0 ? 'fs-4' : 'text-muted'}>{count && count >= 0 ? count : 'nil'} </span>
          {isComparing && <span className="text-muted">| {countTwo && countTwo >= 0 ? countTwo : 'nil'}</span>}
        </div>
        <div style={{ width: '25%', padding: '0.5rem' }} className={count >= 0 ? 'fs-4' : 'text-muted'}>
          {count && count >= 0 ? calculatePercetageOfSecondValue(source.count, count) : 'n/a'}
          {isComparing && <span className="text-muted">| {countTwo && countTwo >= 0 ? calculatePercentageDifference(source.countTwo, countTwo) : 'n/a'}</span>}
        </div>
      </div>
    </div>
  );
}
